module.exports = __webpack_public_path__ + "static/media/3rdpartydevice.c2987184.PNG";


//////////////////
// WEBPACK FOOTER
// ./src/images/3rdpartydevice.PNG
// module id = 1531
// module chunks = 0